import React from 'react';
import { useSelector } from 'react-redux';
import { useCollaboration } from '../../../entities/collaboration';
import { commentsModel } from '../model';
import { ThreadItem } from './ThreadItem';

export const CommentsPreviewList = () => {
  const { threads } = useCollaboration();
  const selectedThreadIds = useSelector(
    commentsModel.selectors.selectSelectedThreadIds
  );
  const threadItems = threads.filter((thread) =>
    selectedThreadIds.includes(thread.id)
  );

  if (threadItems.length < 1) {
    return null;
  }

  return (
    <div className="flex flex-col flex-1 border border-gray-200 rounded-xl shadow-xl overflow-hidden">
      {threadItems.map((thread) => (
        <div
          key={thread.id}
          className="[&:not(:last-child)]:border-b border-gray-200"
        >
          <ThreadItem thread={thread} isCompact />
        </div>
      ))}
    </div>
  );
};
